import Vue from 'vue'
import App from './App.vue'
import store from './store'
import vuetify from './plugins/vuetify'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import './assets/hp-font/hp-font.css'
import '@mdi/font/css/materialdesignicons.css'
import VueRouter from 'vue-router'
import { routes } from './routes'
import Affix from 'vue-affix'

Vue.config.productionTip = false

Vue.use(VueRouter)
Vue.use(Affix)

const router = new VueRouter({ routes: routes, mode: 'hash' })

new Vue({
  store,
  vuetify,
  router,
  render: h => h(App)
}).$mount('#hypertension')
